import React, { useContext } from 'react';
import { IncentivizedArrowIcon, SearchIcon } from '../../../../../assets/icons';
import TableHeader from '../../../../../components/TableHeader';
import spoolsContext from '../../../../../context/spools/spoolsContext';

type Props = {
    hasFilteredResults: boolean;
};

const SpoolCreatorFeesHeader: React.FC<Props> = ({ hasFilteredResults }) => {
    const { activeFilter, searchTerm, setSearchTerm, setActiveFilter } =
        useContext(spoolsContext);

    const handleSearchTermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setSearchTerm(value);
    };

    const handleIncentivizeArrowClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        setActiveFilter('incentivized', !activeFilter.incentivized);
    };

    return (
        <>
            <TableHeader context={spoolsContext} withSort={false} dataKey='name'>
                <div className='search-container'>
                    <SearchIcon />
                    <input
                        type='search'
                        name='searchTerm'
                        autoComplete='off'
                        value={searchTerm}
                        placeholder='Name'
                        onChange={handleSearchTermChange}
                        className={!hasFilteredResults ? 'no-result' : undefined}
                    />
                </div>
            </TableHeader>
            <TableHeader context={spoolsContext} dataKey='apy'>
                <IncentivizedArrowIcon
                    incentivized={activeFilter.incentivized}
                    onClick={handleIncentivizeArrowClick}
                />
                <span>APY</span>
            </TableHeader>
            <TableHeader context={spoolsContext} dataKey='tvr'>
                TVR
            </TableHeader>
            <TableHeader context={spoolsContext} dataKey='ownerFeesCollectedAmount'>
                Earned Fees
            </TableHeader>
            <div/>
        </>
    );
};

export default SpoolCreatorFeesHeader;
